export const EmojiSuperDim = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    fill="none"
    viewBox="0 0 64 64"
  >
    <g clip-path="url(#clip0_5328_192026)">
      <g filter="url(#filter0_f_5328_192026)">
        <path
          fill="#F6F7F8"
          d="M60.97 62.776c0-.07-.183-.139-.538-.205-3.277-.436-13.694-.75-26.035-.75-14.977 0-27.124.468-27.124 1.043 0 .07.184.14.539.205 3.289.436 13.694.751 26.035.751 14.977 0 27.124-.469 27.124-1.044Z"
        />
      </g>
      <path
        fill="#85C0FC"
        d="M52.257 15.785c-1.392 2.496-.346 5.491 2.796 6.475s6.026-1.055 6.439-4.926c.227-2.13-1.092-4.311-1.59-4.902.25.796.35 2.048-.224 2.813-.574.764-1.563 1.03-2.007.892.902-1.093.946-2.75.592-4.125-.34-1.322-1.16-2.326-2.202-3.334.542 1.483.442 2.677-.382 3.78-.93 1.243-2.23 1.191-3.422 3.327Z"
      />
      <path
        fill="url(#paint0_radial_5328_192026)"
        d="M52.257 15.785c-1.392 2.496-.346 5.491 2.796 6.475s6.026-1.055 6.439-4.926c.227-2.13-1.092-4.311-1.59-4.902.25.796.35 2.048-.224 2.813-.574.764-1.563 1.03-2.007.892.902-1.093.946-2.75.592-4.125-.34-1.322-1.16-2.326-2.202-3.334.542 1.483.442 2.677-.382 3.78-.93 1.243-2.23 1.191-3.422 3.327Z"
      />
      <path
        fill="url(#paint1_linear_5328_192026)"
        d="M52.257 15.785c-1.392 2.496-.346 5.491 2.796 6.475s6.026-1.055 6.439-4.926c.227-2.13-1.092-4.311-1.59-4.902.25.796.35 2.048-.224 2.813-.574.764-1.563 1.03-2.007.892.902-1.093.946-2.75.592-4.125-.34-1.322-1.16-2.326-2.202-3.334.542 1.483.442 2.677-.382 3.78-.93 1.243-2.23 1.191-3.422 3.327Z"
      />
      <path
        fill="#85C0FC"
        d="M4.502 17.805c.665 4.495 4.888 7.255 9.802 5.448 4.914-1.807 6.57-7.174 3.336-12.452-1.78-2.903-5.557-4.374-6.758-4.633 1.088.758 2.427 2.24 2.446 3.76.018 1.52-.97 2.815-1.663 3.07.077-2.251-1.475-4.383-3.255-5.772C6.7 5.891 4.693 5.422 2.403 5.161c2.12 1.343 3.153 2.944 3.184 5.133.034 2.468-1.655 3.664-1.085 7.511Z"
      />
      <path
        fill="url(#paint2_radial_5328_192026)"
        d="M4.502 17.805c.665 4.495 4.888 7.255 9.802 5.448 4.914-1.807 6.57-7.174 3.336-12.452-1.78-2.903-5.557-4.374-6.758-4.633 1.088.758 2.427 2.24 2.446 3.76.018 1.52-.97 2.815-1.663 3.07.077-2.251-1.475-4.383-3.255-5.772C6.7 5.891 4.693 5.422 2.403 5.161c2.12 1.343 3.153 2.944 3.184 5.133.034 2.468-1.655 3.664-1.085 7.511Z"
      />
      <path
        fill="url(#paint3_linear_5328_192026)"
        d="M4.502 17.805c.665 4.495 4.888 7.255 9.802 5.448 4.914-1.807 6.57-7.174 3.336-12.452-1.78-2.903-5.557-4.374-6.758-4.633 1.088.758 2.427 2.24 2.446 3.76.018 1.52-.97 2.815-1.663 3.07.077-2.251-1.475-4.383-3.255-5.772C6.7 5.891 4.693 5.422 2.403 5.161c2.12 1.343 3.153 2.944 3.184 5.133.034 2.468-1.655 3.664-1.085 7.511Z"
      />
      <mask
        id="mask0_5328_192026"
        width="45"
        height="45"
        x="12"
        y="6"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <circle cx="34.257" cy="28.031" r="21.984" fill="#fff" />
      </mask>
      <g mask="url(#mask0_5328_192026)">
        <circle cx="34.257" cy="28.031" r="21.984" fill="#85C0FC" />
        <circle
          cx="34.257"
          cy="28.031"
          r="21.984"
          fill="url(#paint4_radial_5328_192026)"
        />
        <circle
          cx="34.257"
          cy="28.031"
          r="21.984"
          fill="url(#paint5_linear_5328_192026)"
        />
        <g filter="url(#filter1_biif_5328_192026)" opacity=".2">
          <path
            fill="#003B80"
            d="M15.935 42.064c.349-2.452 3.55-5.726 6.719-4.475 5.15 2.035 4.557 9.62-.78 16.17-8.44.444-14.914-3.552-13.516-8.91.86-3.298 5.391-3.95 7.577-2.785Z"
          />
        </g>
        <g filter="url(#filter2_f_5328_192026)" opacity=".2">
          <ellipse
            cx="20.974"
            cy="30.515"
            fill="url(#paint6_radial_5328_192026)"
            rx="5.694"
            ry="5.679"
          />
        </g>
        <g filter="url(#filter3_f_5328_192026)" opacity=".2">
          <ellipse
            cx="45.931"
            cy="30.515"
            fill="url(#paint7_radial_5328_192026)"
            rx="5.694"
            ry="5.679"
          />
        </g>
        <g filter="url(#filter4_f_5328_192026)" opacity=".5">
          <path
            fill="url(#paint8_linear_5328_192026)"
            d="M46.78 44.803c5.555-4.304 6.742-8.576 7.569-14.549-1.768 7.06-4.959 10.322-9.546 13.638-5.287 3.822-9.88 4.374-17.658 3.659 6.82 1.74 13.781 1.787 19.634-2.748Z"
          />
        </g>
        <path
          stroke="#0052B3"
          stroke-linecap="round"
          stroke-width="1.68"
          d="M27.717 34.906s1.186 3.048 6.434 3.048 6.434-3.048 6.434-3.048"
          opacity=".6"
        />
        <g filter="url(#filter5_d_5328_192026)">
          <g filter="url(#filter6_d_5328_192026)">
            <ellipse
              cx="44.313"
              cy="21.78"
              fill="url(#paint9_radial_5328_192026)"
              rx="7.804"
              ry="8.266"
              transform="rotate(20 44.313 21.78)"
            />
          </g>
          <ellipse
            cx="48.852"
            cy="26.24"
            fill="url(#paint10_radial_5328_192026)"
            rx=".754"
            ry="1.914"
            transform="rotate(44.325 48.852 26.24)"
          />
          <ellipse
            cx="45.318"
            cy="28.461"
            fill="url(#paint11_radial_5328_192026)"
            rx=".406"
            ry="1.031"
            transform="rotate(77.674 45.318 28.46)"
          />
        </g>
        <g filter="url(#filter7_d_5328_192026)">
          <ellipse
            cx="23.991"
            cy="21.785"
            fill="url(#paint12_radial_5328_192026)"
            rx="7.804"
            ry="8.266"
            transform="rotate(-20 23.99 21.785)"
          />
        </g>
        <circle cx="44.617" cy="19.602" r="2.5" fill="#0052B3" opacity=".6" />
        <circle cx="23.617" cy="19.602" r="2.5" fill="#0052B3" opacity=".6" />
        <ellipse
          cx="30.332"
          cy="22.278"
          fill="#fff"
          rx=".754"
          ry="1.914"
          transform="rotate(4.326 30.332 22.278)"
        />
        <ellipse
          cx="29.053"
          cy="26.259"
          fill="#fff"
          rx=".406"
          ry="1.031"
          transform="rotate(37.674 29.053 26.26)"
        />
      </g>
      <g filter="url(#filter8_d_5328_192026)">
        <path
          fill="url(#paint13_radial_5328_192026)"
          d="M33.922 46.292c.612 1.611 2.607 6.626 5.456 9.62 1.832 1.924 5.01 3.435 7.093 3.26 2.254-.19 5.565-1.965 6.805-5.265l2.16-5.746c.753-2.002-1.069-3.7-2.378-2.377 1.06-2.822-1.894-3.864-2.728-1.645.994-2.645-2.206-4.38-3.376-1.269l2.94-7.822c.799-2.122-2.259-3.204-3.034-1.14l-5.03 13.38c-.352.933-.91 1.666-1.707 1.096-.91-.65-2.172-2.548-3.745-3.657-1.282-.904-3.069-.046-2.456 1.565Z"
        />
      </g>
      <mask
        id="mask1_5328_192026"
        width="19"
        height="17"
        x="3"
        y="32"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "alpha" }}
      >
        <path
          fill="#fff"
          d="M11.55 36.939c.349-2.452 3.55-5.726 6.719-4.475 5.151 2.035 4.557 9.62-.78 16.17-8.439.444-14.913-3.552-13.516-8.91.86-3.298 5.392-3.95 7.577-2.785Z"
        />
      </mask>
      <g mask="url(#mask1_5328_192026)">
        <path
          fill="#85C0FC"
          d="M11.55 36.939c.349-2.452 3.55-5.726 6.719-4.475 5.151 2.035 4.557 9.62-.78 16.17-8.439.444-14.913-3.552-13.516-8.91.86-3.298 5.392-3.95 7.577-2.785Z"
        />
        <path
          fill="url(#paint14_radial_5328_192026)"
          d="M11.55 36.939c.349-2.452 3.55-5.726 6.719-4.475 5.151 2.035 4.557 9.62-.78 16.17-8.439.444-14.913-3.552-13.516-8.91.86-3.298 5.392-3.95 7.577-2.785Z"
        />
        <path
          fill="url(#paint15_linear_5328_192026)"
          d="M11.55 36.939c.349-2.452 3.55-5.726 6.719-4.475 5.151 2.035 4.557 9.62-.78 16.17-8.439.444-14.913-3.552-13.516-8.91.86-3.298 5.392-3.95 7.577-2.785Z"
        />
        <g filter="url(#filter9_f_5328_192026)">
          <circle cx="34.259" cy="28.031" r="21.984" fill="#E6F1FF" />
        </g>
      </g>
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(-6.94482 4.97438 -4.47625 -6.24936 59.175 14.688)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3D6FF" />
        <stop offset=".418" stop-color="#80BAFF" />
        <stop offset=".736" stop-color="#1A83FF" />
        <stop offset="1" stop-color="#006AE6" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(106.806 2.47 9.37) scale(13.5829 12.2227)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3D6FF" />
        <stop offset=".418" stop-color="#80BAFF" />
        <stop offset=".736" stop-color="#1A83FF" />
        <stop offset="1" stop-color="#006AE6" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(43.657 -14.014 44.48) scale(32.7647 30.6393)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3D6FF" />
        <stop offset=".418" stop-color="#80BAFF" />
        <stop offset=".736" stop-color="#1A83FF" />
        <stop offset="1" stop-color="#006AE6" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 5.67932 -5.69444 0 20.974 30.515)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".36" stop-color="#C8CCD0" />
        <stop offset="1" stop-color="#F6F7F8" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(0 5.67932 -5.69444 0 45.93 30.515)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".36" stop-color="#C8CCD0" />
        <stop offset="1" stop-color="#F6F7F8" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -.906 58.977) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(.6841 1.78467 -1.0791 .41364 48.739 25.768)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(69.027 2.118 47.011) scale(1.02953 .62251)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="rotate(47.426 -11.073 35.846) scale(10.4661 9.4336)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(6.61721 17.43735 -15.36495 5.83077 44.787 41.799)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".443" stop-color="#fff" />
        <stop offset=".667" stop-color="#F0F9FF" />
        <stop offset=".833" stop-color="#E3E6E8" />
        <stop offset="1" stop-color="#F0F9FF" />
      </radialGradient>
      <radialGradient
        id="paint14_radial_5328_192026"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(12.62991 2.48469 -2.25794 11.4773 10.205 41.303)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#B3D6FF" />
        <stop offset=".418" stop-color="#80BAFF" />
        <stop offset=".736" stop-color="#1A83FF" />
        <stop offset="1" stop-color="#006AE6" />
      </radialGradient>
      <filter
        id="filter0_f_5328_192026"
        width="56.27"
        height="4.573"
        x="5.987"
        y="60.534"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192026"
          stdDeviation=".643"
        />
      </filter>
      <filter
        id="filter1_biif_5328_192026"
        width="21.245"
        height="19.684"
        x="6.568"
        y="35.713"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation=".4" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_5328_192026"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_5328_192026"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx=".24" dy=".24" />
        <feGaussianBlur stdDeviation=".2" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend in2="shape" result="effect2_innerShadow_5328_192026" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="-.24" dy="-.24" />
        <feGaussianBlur stdDeviation=".2" />
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.46 0 0 0 0 0.5 0 0 0 0 0.54 0 0 0 1 0" />
        <feBlend
          in2="effect2_innerShadow_5328_192026"
          result="effect3_innerShadow_5328_192026"
        />
        <feGaussianBlur
          result="effect4_foregroundBlur_5328_192026"
          stdDeviation=".8"
        />
      </filter>
      <filter
        id="filter2_f_5328_192026"
        width="17.017"
        height="16.987"
        x="12.465"
        y="22.022"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192026"
          stdDeviation="1.407"
        />
      </filter>
      <filter
        id="filter3_f_5328_192026"
        width="17.017"
        height="16.987"
        x="37.422"
        y="22.022"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192026"
          stdDeviation="1.407"
        />
      </filter>
      <filter
        id="filter4_f_5328_192026"
        width="30.421"
        height="21.599"
        x="25.537"
        y="28.65"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192026"
          stdDeviation=".804"
        />
      </filter>
      <filter
        id="filter5_d_5328_192026"
        width="25.855"
        height="26.56"
        x="32.512"
        y="10.186"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192026"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192026"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d_5328_192026"
        width="25.855"
        height="26.56"
        x="32.512"
        y="10.186"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192026"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192026"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d_5328_192026"
        width="25.855"
        height="26.56"
        x="12.189"
        y="10.194"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192026"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192026"
          result="shape"
        />
      </filter>
      <filter
        id="filter8_d_5328_192026"
        width="31.947"
        height="36.513"
        x="29.857"
        y="29.428"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dx="1.126" dy="1.688" />
        <feGaussianBlur stdDeviation="2.533" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.784 0 0 0 0 0.8 0 0 0 0 0.816 0 0 0 1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5328_192026"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_5328_192026"
          result="shape"
        />
      </filter>
      <filter
        id="filter9_f_5328_192026"
        width="46.218"
        height="46.22"
        x="11.15"
        y="4.921"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_5328_192026"
          stdDeviation=".563"
        />
      </filter>
      <linearGradient
        id="paint1_linear_5328_192026"
        x1="61.04"
        x2="55.57"
        y1="10.928"
        y2="13.848"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#B3D6FF" />
        <stop offset=".353" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_5328_192026"
        x1="10.858"
        x2="6.798"
        y1="3.168"
        y2="12.152"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#B3D6FF" />
        <stop offset=".353" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_5328_192026"
        x1="23.804"
        x2="37.392"
        y1="8.23"
        y2="27.456"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#B3D6FF" />
        <stop offset=".353" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_5328_192026"
        x1="46.516"
        x2="39.489"
        y1="44.876"
        y2="37.991"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#1A83FF" />
        <stop offset="1" stop-color="#E6F1FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_5328_192026"
        x1="6.868"
        x2="14.207"
        y1="37.591"
        y2="42.353"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".075" stop-color="#B3D6FF" />
        <stop offset=".353" stop-color="#E6F1FF" />
      </linearGradient>
      <clipPath id="clip0_5328_192026">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
);
